// utils/formSanitize.js
export function sanitizeFormData(input) {
    // handle primitives and null/undefined
    if (input === null || input === undefined) return null;

    // convert strings "n/a", "N/A", "na", empty string -> null
    if (typeof input === "string") {
        const trimmed = input.trim();
        if (trimmed === "" || /^n\/?a$/i.test(trimmed)) return null;
        return input; // keep original string
    }

    // arrays -> map & sanitize each element
    if (Array.isArray(input)) {
        return input.map(item => sanitizeFormData(item));
    }

    // objects -> iterate keys
    if (typeof input === "object") {
        const out = {};
        Object.keys(input).forEach((k) => {
            // If you want to preserve some keys even when empty, add exceptions here
            out[k] = sanitizeFormData(input[k]);
        });
        return out;
    }

    // numbers, booleans, etc. -> return as-is
    return input;
}
